var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.escape
    ? _c("span", _vm._b({ key: _vm.val }, "span", _vm.options, false), [
        _vm._v(_vm._s(_vm.text)),
      ])
    : _c(
        "span",
        _vm._b(
          { key: _vm.val, domProps: { innerHTML: _vm._s(_vm.text) } },
          "span",
          _vm.options,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }